import React from "react";
import {
  makeStyles,
  Grid,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import TravelTime from "../atoms/TravelTime";
import TicketTemplate from "../molecules/TicketTemplate";
import LuggageBadge from "../atoms/LuggageBadge";

import { accentUltraLight } from "../../../constants/colors";
import ArrowRight from "../../../assets/img/arrow-right.svg";
import FlightBadge from "../../../components/FlightBadge/FlightBadge";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  ticket: {
    backgroundColor: accentUltraLight,
    padding: "60px",
    borderRadius: "20px",
    marginBottom: "20px",
    [down("sm")]: {
      padding: "20px 50px",
    },
    [down("xs")]: {
      padding: "18px",
      borderRadius: "10px",
    },
  },
  mobileBlock: {
    display: "none",
    [down("xs")]: {
      display: "flex",
      "& p": {
        fontSize: "12px",
      },
    },
  },
  fullWidth: {
    width: "auto",
    [down("xs")]: {
      width: "100%",
    },
  },
}));

const FlightDetails = ({ flightDetail, flightNumber, type, airlines, airports, badge }) => {
  const classes = useStyles();
  const theme = useTheme();
  const typeName = {
    'depart': 'DEPARTURE TICKET',
    'return': 'RETURN TICKET',
    'multiple': `FLIGHT ${flightNumber}`
  };
  const show = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <Grid item xs={12} className={classes.ticket}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        position="relative"
        flexDirection={{ xs: "column", sm: "row" }}
      >
        {(badge && badge.value === "hotel") && (
          <Box ml={1} position="absolute" right="-10px" top="-25px"  display={{xs:"block", sm:"none"}}>
            <FlightBadge info={badge} withLabel={ true }/>
          </Box>
        )}
        <Box>
          <Typography variant="subtitle1" color="primary">
            {typeName[type]}
          </Typography>
        </Box>
        <Box
          justifyContent={{ xs: "space-between", sm: "center" }}
          mb={1.5}
          mt={1}
          display="flex"
          alignItems="center"
          className={classes.fullWidth}
        >
          <TravelTime
            label="Travel time:"
            value={`${flightDetail.travelTime} · ${flightDetail.stops} Stop`}
          />
          <Box className={classes.mobileBlock}>
            {!!flightDetail.baggage && (
              <LuggageBadge count={flightDetail.baggage} weight={flightDetail.baggageWeight}/>
            )}
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent={{ xs: "center", sm: "space-between" }}
      >
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "center" }}
        >
          <Box display="flex">
            <Typography variant="h4">
              <b>{airports[flightDetail.from]?.city}</b>
            </Typography>
            <Box mr={1} ml={1} display="flex" justifyContent="center" alignItems="center">
              <img src={ArrowRight} alt="arrow-right" width="17" height="10"/>
            </Box>
            <Typography variant="h4">
              <b>{airports[flightDetail.to]?.city}</b>
            </Typography>
          </Box>
          <Box ml={1}>
            <Typography variant="h4">{flightDetail.date}</Typography>
          </Box>
        </Box>
        {!!flightDetail.baggage && !show && (
          <LuggageBadge count={flightDetail.baggage} weight={flightDetail.baggageWeight}/>
        )}
      </Box>
      {flightDetail.segments?.map((segment) => (
        <TicketTemplate
          ticketInfo={segment}
          key={segment?.id}
          airlines={airlines}
          airports={airports}
        />
      ))}
    </Grid>
  );
};

export default FlightDetails;
